import useParkingHistoryFilter from 'hooks/useParkingHistoryFilter';
import React from 'react';
import { useMapStore } from 'stores/mapStore';
import FilterButton from './FilterButton';
import { useUiStore } from 'stores/uiStore';

export const HistoryFilterButtonWithTypes = () => (
  <HistoryFilterButton showParkingTypes />
);

export const HistoryFilterButtonNoTypes = () => (
  <HistoryFilterButton showParkingTypes={false} />
);

const HistoryFilterButton = ({
  showParkingTypes,
}: {
  showParkingTypes: boolean;
}) => {
  const { filterActive } = useParkingHistoryFilter();
  return (
    <FilterButton
      testID="history"
      isActive={filterActive}
      onPress={() => {
        useMapStore.getState().setParkingTypesVisible(showParkingTypes);
        useUiStore.getState().setSheetModal('parkingHistoryFilter');
      }}
    />
  );
};
